import moment from "moment";
import _ from "lodash";

export default (plan) => {
  // promise
  return new Promise((resolve, reject) => {
    const fromDate = moment("2022-08-01");
    const toDate = moment("2023-08-01");
    const items = [];
    const fields = [];
    // Create list of weeks between two dates
    const weeks = [];
    while (fromDate.isBefore(toDate)) {
      weeks.push(fromDate.format("WW-YYYY"));
      fromDate.add(1, "week");
    }

    const subplans = Object.keys(_.groupBy(plan, "subplan"));

    for (let i = 0; i < weeks.length; i++) {
      const item = {
        week: weeks[i]
      };
      for (let subplan of subplans) {
        const planItems = plan.filter((p) => p.week === weeks[i] && p.subplan === subplan);
        item[subplan] = {};
        item[subplan]["percentage"] = 0;
        item[subplan]["current"] = 0;
        item[subplan]["total"] = 0;
        if (planItems.length > 0) {
          const value = planItems.reduce((a, b) => a + parseFloat(b.kilograms), 0);
          const current = planItems.reduce((a, b) => a + parseFloat(b.completed_kilograms || 0), 0);
          const percentage = (current / value) * 100;
          item[subplan]["percentage"] = percentage;
          item[subplan]["current"] = current;
          item[subplan]["total"] = value;
        }
      }
      const totalByWeekItems = plan.filter((p) => p.week === weeks[i]);
      const totalKilogramsPerWeek = totalByWeekItems.reduce((a, b) => a + parseFloat(b.kilograms), 0);
      item["total"] = totalKilogramsPerWeek;
      items.push(item);
    }

    fields.push({ key: "week", stickyColumn: true, isRowHeader: true, variant: "secondary", class: "w-5 " });
    for (let subplan of subplans) {
      fields.push({ key: subplan, class: "text-center" });
    }
    fields.push({
      key: "total",
      stickyColumn: true,
      isRowHeader: true,
      variant: "secondary",
      class: "text-center w-5"
    });

    resolve({ items, fields });
  });
};
